module.exports = __webpack_public_path__ + "static/media/old_practice_version_1.de4b4425.png";